import { render, staticRenderFns } from "./TargetTab.vue?vue&type=template&id=b6baa688"
import script from "./TargetTab.vue?vue&type=script&lang=js"
export * from "./TargetTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports